import React from "react";
import _ from "lodash";
import { _getTranslation } from "../utils/helper";

import { FieldWrapper } from ".";
import { RatingStars } from "../atoms";

const InputRating = ({ label, error, value, onChange, ...props }) => {
  return (
    <FieldWrapper label={label} error={_.isString(error) && error}>
      <div className="rating-input">
        {Array.from({ length: 5 }, (item, i) => i + 1)
          .reverse()
          .map((ratingOption) => (
            <label key={ratingOption} className="flex items-center gap-x-4">
              <input
                type="radio"
                name={props.name || _getTranslation("rating")}
                checked={ratingOption === value}
                value={ratingOption}
                onChange={(e) => {
                  onChange(parseInt(e.target.value));
                }}
              />

              <div className="flex items-center justify-center gap-x-2">
                <RatingStars currentRating={ratingOption} />
              </div>

              <div className="text-mobileS md:text-desktopS">
                {ratingOption} Star{ratingOption !== 1 && "s"}
              </div>
            </label>
          ))}
      </div>
    </FieldWrapper>
  );
};

export default InputRating;
